import { saveAs } from 'file-saver'
const FileUtil = {
  /**
   * 浏览器保存文本文件
   * @param {*} str
   * @param {*} fileName
   */
  saveFile(str, fileName) {
    saveAs(
      new Blob([str], {
        type: 'text/plain;charset=utf-8',
      }),
      fileName
    )
  },
  saveImage(url, filename) {
    saveAs(url, filename)
  },
}
export default FileUtil
